import {Flex, Icon, Image, Text} from '@chakra-ui/react'
import Close from '@assets/svgs/close.svg'
import {ReactComponent as ExclamationCircle} from '@assets/svgs/exclamation-circle.svg'
import {updateIsShowConfirmClose} from '@redux/gym/gymSlice'
import {useDispatch, useSelector} from 'react-redux'
import {
  updateIsShowModalExitFlow,
  updateIsShowReportErrorForm,
} from '@redux/shared/shared'
import {useLocation} from 'react-router-dom'
import {getFeedbackExitFlowType} from '@utils'

const TopTitle = ({lessonName, type}: {lessonName: any; type: any}) => {
  const {dataFeedbackOverview} = useSelector((state: any) => state.shared)
  const {entry_point} = useLocation().state || {}
  const dispatch = useDispatch()
  let lessonTitle

  switch (type) {
    case 'HOC_PHAT_AM':
      lessonTitle = 'Hướng dẫn phát âm'
      break
    case 'CAP_TU':
      lessonTitle = 'Phân biệt cặp từ'
      break
    case 'LUYEN_TAP':
      lessonTitle = 'Luyện tập phát âm'
      break

    default:
      lessonTitle = ''
      break
  }

  const handleClickClose = () => {
    if (
      entry_point === 'ROADMAP' &&
      !dataFeedbackOverview?.feedback_data[
        getFeedbackExitFlowType(location.pathname)
      ]?.is_completed
    ) {
      dispatch(updateIsShowModalExitFlow(true))
    } else {
      dispatch(updateIsShowConfirmClose(true))
    }
  }

  return (
    <Flex
      h={'64px'}
      bg={'#D1E9FF'}
      justifyContent={'center'}
      alignItems={'center'}>
      <Flex
        w={'1000px'}
        justifyContent={'space-between'}
        px={{base: '16px', lg: '0px'}}>
        <Image src={Close} onClick={handleClickClose} cursor={'pointer'} />
        <Text fontSize={{base: '17px', md: '20px'}} fontWeight={600}>
          {`${lessonName} ${lessonTitle}`}
        </Text>
        <Icon
          w={'24px'}
          h="24px"
          viewBox="0 0 24 24"
          cursor={'pointer'}
          sx={{
            path: {
              fill: '#000000',
            },
          }}
          onClick={() => {
            dispatch(updateIsShowReportErrorForm(true))
          }}>
          <ExclamationCircle />
        </Icon>
      </Flex>
    </Flex>
  )
}

export default TopTitle
